import { Link as ShrikeLink } from '@perch-labs/shrike';
import { ComponentProps, PropsWithChildren } from 'react';
import { FlexboxProps, LayoutProps, TypographyProps } from 'styled-system';
import { trackEvent, LegacyTrackingEvent } from '~/utils/tracking';
import { StyledLink } from './link.style';

type StyledSystemProps = Omit<
  FlexboxProps & LayoutProps & TypographyProps,
  'fontSize' | 'size' | 'textAlign'
>;
type ShrikeLinkProps = ComponentProps<typeof ShrikeLink>;

export type LinkProps = StyledSystemProps &
  ShrikeLinkProps & {
    testId?: string;
    track?: LegacyTrackingEvent;
  };

export const Link = (props: PropsWithChildren<LinkProps>) => {
  const { children, onClick, openInNewTab = true, testId, track, type = 'inline' } = props;

  return (
    <StyledLink
      {...props}
      type={type}
      data-testid={testId}
      openInNewTab={openInNewTab}
      onClick={e => {
        if (track) trackEvent(track);
        if (onClick) onClick(e);
      }}
    >
      {children}
    </StyledLink>
  );
};
